import Axios from "axios";

import type { LanguageId } from "../util/languages";

export interface User {
  id: number;
  name: string;
  picture: string;
  username: string;
  learningLanguage: LanguageId;
  fromLanguage: LanguageId;
  email?: string;
  currentCourseId: string;
}

interface UserSearchResponse {
  users: User[];
}

const USER_FIELDS = [
  "id",
  "name",
  "picture",
  "username",
  "learningLanguage",
  "fromLanguage",
  "email",
  "currentCourseId",
].join(",");

const client = Axios.create({
  baseURL: `${process.env.REACT_APP_API_V2_ORIGIN}/2023-05-23`,
});

const getUser = async (userId: number) =>
  (
    await client.get<User>(`/users/${userId}`, {
      params: {
        fields: USER_FIELDS,
      },
      withCredentials: true,
    })
  ).data;

const searchUserByUsername = async (username: string) =>
  (
    await client.get<UserSearchResponse>("/users", {
      params: {
        fields: `users{${USER_FIELDS}}`,
        username,
      },
      withCredentials: true,
    })
  ).data.users;

export const apiV2 = {
  getUser,
  searchUserByUsername,
};
